
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface DeleteItem {
  tableName: string
  PK: string
  SK: string
  primaryKey?: string
  sortKey?: string
  pkValue?: string
  skValue?: string
}

export const useBatchDeleteTasks = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (deletions: DeleteItem[]) => axios.post(`${baseUrl}/aws/tasks/batch-delete`, { deletions }),
    onSuccess: () => {
      // Invalidate any relevant queries here
      queryClient.invalidateQueries({ queryKey: ['teamtasks'] }) // adjust as needed
    },
    onError: err => {
      console.error('Batch delete failed:', err)
    },
  })
}
